import { KNOB_DIRECTIONS } from 'crazyEditor/core/constants/editorConstants';

export default {
  draggable: {x: true, y: true},
  hoverable: true,
  resizable: [
    KNOB_DIRECTIONS.MIDDLE_LEFT,
    KNOB_DIRECTIONS.MIDDLE_RIGHT,
  ],
  fullWidth: false,
  selectable: true,
  isTextElement: true,
  fontSelectable: true,
  paddingSelectable: true,
  autoHeight: true,
  hyperlinkEnabled: true,
  templateTagProps: {
    resizable: [
      KNOB_DIRECTIONS.TOP_LEFT,
      KNOB_DIRECTIONS.TOP_RIGHT,
      KNOB_DIRECTIONS.TOP_MIDDLE,
      KNOB_DIRECTIONS.MIDDLE_LEFT,
      KNOB_DIRECTIONS.MIDDLE_RIGHT,
      KNOB_DIRECTIONS.BOTTOM_LEFT,
      KNOB_DIRECTIONS.BOTTOM_RIGHT,
      KNOB_DIRECTIONS.BOTTOM_MIDDLE
    ],
    autoHeight: false,
  },
  publish: {
    autoHeight: true,
  }
};
